/* mw-core: drawers/menu (focus trap, Esc, scrim), dropdown de Ocasioes do header
   (so Escape e fechar ao sair; abrir e nativo), porta +18, launcher, stepper.
   Progressive enhancement: tudo funciona sem este arquivo (rule performance-a11y). */
(function () {
  'use strict';
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;

  /* ---------- drawers (cart, curador, menu) ---------- */
  var aberto = null;
  var focoAnterior = null;
  var rolY = null; /* scrollY guardado pelo corpo fixo (html.mw-fixo, critical.css); null = corpo solto */

  function drawer(nome) { return qs('[data-mw-drawer="' + nome + '"]'); }

  function focaveis(el) {
    return qsa('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
  }

  function abrir(nome, quem) {
    var el = drawer(nome);
    if (!el) return;
    if (aberto && aberto !== nome) fechar();
    /* reaberto sem fechar (pergunta com o drawer ja aberto): o foco de volta
       continua o de quem abriu, nunca um botao de dentro do proprio drawer. No
       toque do Safari o botao nao ganha foco (o ativo e o body): a volta e o
       proprio botao tocado (`quem`, do clique delegado abaixo). */
    if (aberto !== nome) {
      var a = document.activeElement;
      focoAnterior = a === document.body && quem ? quem : a;
    }
    aberto = nome;
    /* o menu fica colado embaixo do cabecalho: mede de novo (a fonte pode ter
       trocado depois da ultima medida). Carrinho e Curador cobrem a tela: corpo
       fixo onde estava, antes do foco, que nao pode rolar a pagina. Reaberto sem
       fechar (chip com o Curador aberto) ja esta fixo e mantem o scrollY. O menu
       nao usa o corpo fixo (levaria o cabecalho sticky junto): o arrasto no iPhone
       e seguro pelo CSS do veu e do painel (touch-action, overscroll-behavior). */
    if (nome === 'menu') medirCab();
    else if (rolY === null) {
      rolY = pageYOffset;
      html.style.setProperty('--mw-y', -rolY + 'px');
      html.classList.add('mw-fixo');
    }
    el.removeAttribute('hidden');
    html.classList.add('mw-travado');
    qsa('[data-mw-abre="' + nome + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    atualizarLauncher();
    var f = focaveis(el);
    (f[0] || el).focus();
    document.dispatchEvent(new CustomEvent('mw:drawer', { detail: { nome: nome, aberto: true } }));
  }

  function fechar() {
    if (!aberto) return;
    var el = drawer(aberto);
    if (el) el.setAttribute('hidden', '');
    qsa('[data-mw-abre="' + aberto + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    html.classList.remove('mw-travado');
    /* devolve a pagina ao ponto de antes, e so depois o foco (que ja esta na tela) */
    if (rolY !== null) {
      html.classList.remove('mw-fixo');
      scrollTo(0, rolY);
      rolY = null;
    }
    aberto = null;
    atualizarLauncher();
    if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
  }

  /* ---------- <details> "Ocasioes" do header (plano 11.3b) ----------
     Abrir e fechar por clique e NATIVO do <details> (padrao Dawn, zero JS). Aqui
     mora so o que o elemento nao da de graca: fechar por Escape devolvendo o foco
     ao summary, e fechar quando o clique ou o foco sai do dropdown. Sem isso o
     menu ficava aberto atras da navegacao seguinte. `exceto` e o <details> que o
     proprio evento acabou de tocar: fechar ele aqui brigaria com o toggle nativo,
     que so acontece depois deste handler. */
  var OC_SEL = '.mw-header-oc-det';
  function fecharOc(exceto) {
    qsa(OC_SEL + '[open]').forEach(function (d) { if (d !== exceto) d.open = false; });
  }
  document.addEventListener('focusin', function (e) { fecharOc(e.target.closest(OC_SEL)); });

  document.addEventListener('click', function (e) {
    fecharOc(e.target.closest(OC_SEL));
    var alvo = e.target.closest('[data-mw-abre]');
    if (alvo) {
      e.preventDefault();
      var n = alvo.getAttribute('data-mw-abre');
      /* o botao do menu vira X com o menu aberto (P14c, sections/header.liquid):
         o veu nao o cobre mais, e o mesmo toque fecha */
      if (n === 'menu' && aberto === n) fechar();
      else abrir(n, alvo);
      return;
    }
    /* link dentro do menu (ancora na mesma pagina inclusive): fecha o menu e deixa navegar */
    if (aberto === 'menu' && e.target.closest('[data-mw-drawer="menu"] a')) {
      fechar();
      return;
    }
    if (e.target.closest('[data-mw-fecha]') || e.target.hasAttribute('data-mw-scrim')) {
      e.preventDefault();
      fechar();
    }
  });

  /* `x`: o botao do cabecalho que vira o X com o menu aberto (P14c). Ele fica
     fora do painel do menu, entao entra na volta do Tab como primeiro item: X ->
     Vinhos -> ... -> Entrar -> X (padrao de dialogo da W3C; no Dawn o X fica
     dentro da area presa). No HTML o X vem antes do logo, da busca e do
     carrinho: a ultima linha leva o Tab do X direto ao primeiro item do menu, e
     o Shift+Tab do primeiro item ao X. Porta, carrinho e Curador passam sem `x`
     e seguem o caminho de sempre. */
  function prenderTab(e, raiz, x) {
    var f = focaveis(raiz);
    if (x && x.offsetParent !== null) f.unshift(x); else x = null;
    if (!f.length) return;
    var a = document.activeElement, i = f.indexOf(a);
    var primeiro = f[0], ultimo = f[f.length - 1];
    if (e.shiftKey && a === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && a === ultimo) { e.preventDefault(); primeiro.focus(); }
    else if (x && i === (e.shiftKey ? 1 : 0)) { e.preventDefault(); f[e.shiftKey ? 0 : 1].focus(); }
  }

  document.addEventListener('keydown', function (e) {
    /* porta +18 visivel: focus trap sem saida por Esc (gate de compliance) */
    if (e.key === 'Tab' && portaVisivel()) { prenderTab(e, porta); return; }
    if (e.key === 'Escape') {
      /* dropdown de Ocasioes antes do drawer: e o disclosure mais interno aberto */
      var oc = qs(OC_SEL + '[open]');
      if (oc) { oc.open = false; oc.firstElementChild.focus(); return; }
    }
    if (!aberto) return;
    if (e.key === 'Escape') { fechar(); return; }
    if (e.key !== 'Tab') return;
    /* focus trap do drawer aberto (o menu leva o X do cabecalho junto) */
    prenderTab(e, drawer(aberto), aberto === 'menu' ? qs('[data-mw-abre="menu"]') : null);
  });

  /* ---------- porta +18 ---------- */
  var porta = qs('[data-mw-porta]');
  function portaVisivel() { return porta && !porta.hasAttribute('hidden'); }

  function mostrarPorta() {
    if (!porta) return;
    html.classList.remove('mw-18ok');
    porta.removeAttribute('hidden');
    html.classList.add('mw-travado');
    atualizarLauncher();
    var f = focaveis(porta);
    if (f[0]) f[0].focus();
  }

  if (porta) {
    try {
      if (localStorage.getItem('mw_maior18') !== '1') mostrarPorta();
      else porta.setAttribute('hidden', '');
    } catch (e) { porta.setAttribute('hidden', ''); }

    porta.addEventListener('click', function (e) {
      if (e.target.closest('[data-mw-porta-sim]')) {
        e.preventDefault();
        try { localStorage.setItem('mw_maior18', '1'); } catch (err) {}
        porta.setAttribute('hidden', '');
        html.classList.add('mw-18ok');
        html.classList.remove('mw-travado');
        atualizarLauncher();
      } else if (e.target.closest('[data-mw-porta-nao]')) {
        e.preventDefault();
        porta.setAttribute('data-mw-barrada', '');
      }
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mw-reconfirmar]')) {
      e.preventDefault();
      try { localStorage.removeItem('mw_maior18'); } catch (err) {}
      if (porta) { porta.removeAttribute('data-mw-barrada'); mostrarPorta(); window.scrollTo(0, 0); }
    }
  });

  /* ---------- launcher do Curador (some com qualquer drawer aberto e com a porta) ----------
     Com o menu do celular aberto ele ficava por cima das ocasioes, e o toque
     abria o Curador no lugar da ocasiao (J1, plano do lancamento de 2026-09-25). */
  function atualizarLauncher() {
    var l = qs('[data-mw-launcher]');
    if (!l) return;
    if (aberto || portaVisivel()) l.setAttribute('hidden', '');
    else l.removeAttribute('hidden');
  }
  atualizarLauncher();

  /* ---------- stepper de quantidade ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mw-menos],[data-mw-mais]');
    if (!b) return;
    var box = b.closest('[data-mw-stepper]');
    var input = box && qs('input', box);
    if (!input) return;
    e.preventDefault();
    var v = parseInt(input.value, 10) || 1;
    v += b.hasAttribute('data-mw-mais') ? 1 : -1;
    /* teto = o max do input (estoque menos o carrinho, na PDP; P7 do lancamento) */
    input.value = Math.min(input.max || 99, Math.max(1, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- altura real do cabecalho -> --mw-header-h ----------
     A barra de filtros sticky da PLP tem que colar embaixo do header sticky.
     Nenhum valor fixo sobrevive: a altura muda com o clamp do logo E o header
     quebra em duas linhas entre 769 e 899px (a busca desce), indo a ~103px.
     Padrao consagrado pra sticky sob header de altura desconhecida: medir com
     ResizeObserver e publicar num custom property (MDN/Smashing).
     Sem JS ou sem ResizeObserver, vale o fallback em calc() do
     snippets/css-variables.liquid - por isso o setProperty mora aqui e nao
     substitui a definicao CSS. getBoundingClientRect (nao contentRect) porque
     o que importa e o border-box: o header tem border-bottom de 1px.
     O menu do celular tambem comeca nessa medida. Sem ResizeObserver (Safari
     abaixo de 13.1, o iPad do dono) mede no carregamento e a cada resize; sem
     isso o menu abriria no fallback de 69px, por cima da busca (a barra real
     do celular tem ~123px). O abrir('menu') mede de novo. */
  var cab = qs('.mw-header');
  function medirCab() {
    if (cab) html.style.setProperty('--mw-header-h', cab.getBoundingClientRect().height + 'px');
  }
  if (window.ResizeObserver) { if (cab) new ResizeObserver(medirCab).observe(cab); }
  else { medirCab(); window.addEventListener('resize', medirCab); }

  /* API publica minima pros outros modulos */
  window.MW = { abrir: abrir, fechar: fechar };
})();
